import { render, staticRenderFns } from "./pWareList.vue?vue&type=template&id=d6a39e84&scoped=true&"
import script from "./pWareList.vue?vue&type=script&lang=js&"
export * from "./pWareList.vue?vue&type=script&lang=js&"
import style0 from "./pWareList.vue?vue&type=style&index=0&id=d6a39e84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a39e84",
  null
  
)

export default component.exports